export default {
  computed: {
    pickerLocale() {
      return this.$i18n.locale === 'en' ? 'en-US' : 'es-SV';
    },
  },
};
